import * as yup from 'yup'
import { PersonAddressDto, PersonDto } from 'dtos'

export class BuildABoxFedExReturnLabelManagementDto {
  fedExReturnTrackingNumber?: string | null = undefined
  fedExReturnPackageType?: string | null = undefined
  fedExReturnShipDate?: string | null = undefined
  // fedExReturnShipTime?: string | null = undefined
  fedExReturnDeliveryType?: string | null = undefined
  fedExReturnWeight?: string | null = undefined
  fedExReturnTitleClerk?: PersonDto = undefined
  fedExReturnTitleClerkAddress?: PersonAddressDto = undefined
}

export const buildABoxFedExReturnLabelManagementValidationSchema = yup.object({
  //   fedExReturnPackageType: yup.string().required('FedEx Return Package Type is required.'),
  //   fedExReturnShipDate: yup.string().required('FedEx Return Ship Date is required.'),
  //   fedExReturnShipTime: yup.string().required('FedEx Return Ship Time is required.'),
  //   fedExReturnDeliveryType: yup.string().required('FedEx Return Delivery Type is required.'),
  //   fedExReturnWeight: yup.string().required('FedEx Return Weight is required.')
  //   // fedExReturnTitleClerk: yup.object().required('FedEx Return Title Clerk is required.'),
  //   // fedExReturnTitleClerkAddress: yup.object().required('FedEx Return Title Clerk Address is required.')
})
